import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App";

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root")
);

if ("serviceWorker" in navigator && "PushManager" in window) {
	window.addEventListener("load", async () => {
		try {
			const registration = await navigator.serviceWorker.register("/custom-service-worker.js");
			//console.log("Service Worker registrado:", registration);
		} catch (err) {
			console.error("Erro ao registrar o Service Worker:", err);
		}
	});
}


// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
